import { CheckNotes, InspectionCase } from '../inspection-cases';

export class DetectorsInstallationDto extends InspectionCase {
  item_7_1?: InspectionCase;
  item_7_2?: InspectionCase;
  item_7_3?: InspectionCase;
}

export class DetectorsInstallation extends DetectorsInstallationDto {
  constructor(data: DetectorsInstallationDto = { title: 'התקנת גלאים' }) {
    super(data);
    this.item_7_1 = new InspectionCase({
      ...data.item_7_1,
      title: 'הגלאים תוכננו / הותקנו במרחקים בין אחד לשני, בהתאם לדרישות התקן'
    });
    this.item_7_2 = new InspectionCase({
      ...data.item_7_2,
      title: 'הגלאים תוכננו / הותקנו במרחקים מהקירות, בהתאם לדרישות התקן'
    });
    this.item_7_3 = new InspectionCase({
      ...data.item_7_3,
      title: `בפרוזדורים מעל תקרות מונמכות תוכננו / הותקנו גלאים בהתאם לדרישות התקן ( נדרשת התקנת גלאים כאשר גובה החלל עולה על 60 ס"מ)`
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.item_7_1.isApplicable || this.item_7_1.isPassed) &&
        (!this.item_7_2.isApplicable || this.item_7_2.isPassed) &&
        (!this.item_7_3.isApplicable || this.item_7_3.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.item_7_1.getNotes(),
      ...this.item_7_2.getNotes(),
      ...this.item_7_3.getNotes()
    ];
  }
}
